exports = module.exports = require("./node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!./node_modules/css-loader/index.js!perfect-scrollbar/css/perfect-scrollbar.css"), "");

// module
exports.push([module.id, ".ps-container{position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-44138184!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./index.vue
// module id = 5
// module chunks = 0